import type { BillingMethodResource } from '@/features/billing/api/resources/billing-method'
import type {
  BillingMethodProps,
  BillingMethodType,
} from '@/features/billing/profile/BillingMethod'

/**
 * Maps a billing method.
 */
export function mapBillingMethodResourceToProps(
  resource: BillingMethodResource,
): Partial<BillingMethodProps> {
  return {
    id: resource.id,
    workspaceId: resource.workspace_id,
    type: mapBillingMethodResourceToType(resource),
  }
}

function mapBillingMethodResourceToType(
  resource: BillingMethodResource,
): BillingMethodType {
  switch (resource.type) {
    case 'Stripe':
    case 'StripeCardPaymentMethod':
      return {
        type: resource.type,
        brand: resource.brand,
        last4: resource.last4,
        expMonth: resource.exp_month,
        expYear: resource.exp_year,
      }
    case 'Credit':
      return {
        type: resource.type,
        balance: resource.balance,
        limit: resource.limit,
      }
  }
  // The API may send values this build doesn't know yet.
  return { type: 'Unknown', rawType: (resource as { type: string }).type }
}
